import { useState } from "react";
import { Menu } from "lucide-react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-100">
      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Mobile hamburger (floating, only shows on <lg) */}
      <button
        onClick={() => setSidebarOpen(true)}
        className="lg:hidden fixed top-4 left-4 z-30 flex h-10 w-10 items-center justify-center rounded-lg bg-white border border-slate-200 shadow-sm hover:bg-slate-50"
        aria-label="Open menu"
        data-testid="mobile-menu-btn"
      >
        <Menu size={22} />
      </button>

      {/* Main Content */}
      <div className="lg:ml-72 flex min-h-screen flex-col">
        <main className="flex-1 w-full p-6 pt-20 lg:pt-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
